var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { FormattedCurrency } from "@irati/utils/lang";
import { TD_STYLE } from "@irati/ui/src/Table";
import { StyledColumn } from "./styled";
import { TooltipHeader, PopularPerks } from "../../../Renderers";
var columns = function (formatMessage, currency, isSavingsEnabled) { return [
    {
        Header: formatMessage({ id: "admin.reportingV2.popularPerks.perk" }),
        accessor: "header",
        minWidth: 700,
        Cell: function (props) { return React.createElement(PopularPerks, __assign({}, props, { headerAccessor: "_original.header", logoUrl: "_original.logo_url" })); },
        style: __assign(__assign({}, TD_STYLE), { border: "none" })
    },
    {
        Header: formatMessage({ id: "admin.reportingV2.popularPerks.totalRedemptions" }),
        id: "redemption_count",
        accessor: function (_a) {
            var redemption_count = _a.redemption_count;
            return React.createElement(StyledColumn, null, redemption_count);
        },
        minWidth: 170,
        style: __assign(__assign({}, TD_STYLE), { border: "none" })
    },
    {
        Header: function (props) { return (React.createElement(TooltipHeader, __assign({ header: "admin.reportingV2.popularPerks.savings", toolTipText: "admin.reportingV2.popularPerks.savingsToolTip" }, props))); },
        id: "estimated_perks_savings",
        accessor: function (_a) {
            var estimated_perks_savings = _a.estimated_perks_savings;
            return (React.createElement(StyledColumn, null,
                React.createElement(FormattedCurrency, { currency: currency, value: estimated_perks_savings })));
        },
        minWidth: 170,
        style: __assign(__assign({}, TD_STYLE), { border: "none" }),
        show: isSavingsEnabled
    }
]; };
export default columns;
